<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import WorkOrderSelectCell from "./_modules/work-order-select-cell"
  import type {
    AssignWorkOrderDraft,
    WorkOrderAssignmentRow,
    WorkOrderAssignmentSelection,
  } from "../../contract"

  let props: InboxWorkflowCellProps = $props()

  const row = $derived(props.row as unknown as WorkOrderAssignmentRow)
  const draft = $derived(props.draft as AssignWorkOrderDraft)

  const handleSelectionChange = (
    _row: WorkOrderAssignmentRow,
    selection: WorkOrderAssignmentSelection | null,
  ) => {
    props.patchDraft({
      workOrderId: selection?.id ?? null,
      selectedWorkOrder: selection,
    })
  }
</script>

<WorkOrderSelectCell
  {row}
  {draft}
  organizationId={props.organizationId ?? ""}
  disabled={props.binding.disabled}
  onSelectionChange={handleSelectionChange}
/>
